import hiIcon from '@/features/user-center/images/currency-icon/INR.png';
import ptIcon from '@/features/user-center/images/currency-icon/BRL.png';
import esIcon from '@/features/user-center/images/currency-icon/MXN.png';
import urIcon from '@/features/user-center/images/currency-icon/PKR.png';
import ukIcon from '@/features/user-center/images/currency-icon/uk.png';
import { CodeStatus } from './hooks/useCfTokenCodeStatus';

export enum VerifyMethod {
  Phone = 1,
  Email = 2
}

// export const VERIFY_METHOD_OPTIONS = [
//   {
//     value: VerifyMethod.Phone,
//     label: '手机'
//   },
//   {
//     value: VerifyMethod.Email,
//     label: '邮箱'
//   }
// ];

export const LANGUAGE_OPTIONS = [
  { label: 'English', value: 'en', icon: 'USD' },
  // { label: 'Chinese', value: 'zh' },
];

export const LANGUAGE_ICON_MAP = {
  'en-US': ukIcon,
  'hi-IN': hiIcon,
  'pt-BR': ptIcon,
  'es-MX': esIcon,
  'ur-PK': urIcon,
};
export const LANGUAGE_NAME_MAP = {
  'en-US': 'en',
  'hi-IN': 'hi',
  'pt-BR': 'pt',
  'es-MX': 'es',
  'ur-PK': 'ur',
};

export enum GameType {
  Casino = 1,
  Fantasy = 2,
  Rummy = 3,
  Sports = 4
}

export const errorCodeTrackReasonMap = {
  [CodeStatus.BLACKLISTED]: 'Blacklist',
  [CodeStatus.FORMAT_ERROR]: 'Invalid recipient account format',
  // [CodeStatus.NEED_CAPTCHA]: authT('cloudflare.text1'),
  [CodeStatus.SEND_FROZEN]: 'Account frozen due to frequent sending',
};

// 虚拟银行卡标识
export const virtualBankCardNumber = 'AIRP0000001';